import React, { useState } from "react";
import HorizontalScroll from "./horizontal_scroll";
import BottomSheet from "./AmenitiesSheet";
const Amenities = ({ amenities }) => {
  const [isBottomSheetOpen, setBottomSheetOpen] = useState(false);
  return (
    <div className="my-5">
      {/* {console.log(amenities)} */}
      <div className="px-6 sm:p-6 flex flex-col items-start">
        <div className="flex flex-row justify-between items-center w-[100%]">
          <div className="text-[#FFFFFF] font-poppins font-light text-[22px]">
            Amenities
          </div>
          <div
            className="text-[#FFFFFF] font-poppins font-light text-xs underline  decoration-white underline-offset-2 decoration-2"
            onClick={() => setBottomSheetOpen(true)}
          >
            View All
          </div>
        </div>

        <div className="text-[#9CA3AF] font-poppins text-[13px]">
          For More Comfortable Stay
        </div>
      </div>
      <HorizontalScroll amenities={amenities} />
      {isBottomSheetOpen && (
        <BottomSheet
          amenities={amenities}
          onClose={() => setBottomSheetOpen(false)}
        />
      )}
    </div>
  );
};

export default Amenities;
